export default "__VITE_PUBLIC_ASSET__aee1d3e4__"